import { dataColors } from "../../shared/design/dataColors";

/**
 * Booking status vocabulary shared by every admin surface. Keep labels here
 * so "Ирсэн / Ирээгүй" read the same on the list, calendar, detail and
 * dashboard.
 */
export type BookingStatus =
  "PENDING" | "CONFIRMED" | "CANCELLED" | "COMPLETED" | "NO_SHOW";

export type BookingStatusColor =
  "default" | "warning" | "success" | "error" | "info";

const LABELS: Record<BookingStatus, string> = {
  PENDING: "Хүлээгдэж буй",
  CONFIRMED: "Баталгаажсан",
  CANCELLED: "Цуцлагдсан",
  COMPLETED: "Ирсэн",
  NO_SHOW: "Ирээгүй",
};

const COLORS: Record<BookingStatus, BookingStatusColor> = {
  PENDING: "warning",
  CONFIRMED: "success",
  CANCELLED: "error",
  COMPLETED: "info",
  NO_SHOW: "default",
};

/** Calendar event fill/border per status. */
export const bookingStatusEventColors = (): Record<BookingStatus, { bg: string; border: string }> =>
  dataColors().status;

export const BOOKING_STATUS_FILTER_OPTIONS: Array<"" | BookingStatus> = [
  "",
  "PENDING",
  "CONFIRMED",
  "COMPLETED",
  "NO_SHOW",
  "CANCELLED",
];

export function bookingStatusLabel(status: string): string {
  return LABELS[status as BookingStatus] ?? status;
}

export function bookingStatusColor(status: string): BookingStatusColor {
  return COLORS[status as BookingStatus] ?? "default";
}
